export enum FeatureFlags {
  OnlinePayment = 'online-payment',
  OnlinePaymentCart = 'online-payment-cart',
  HelixExpressAd = 'helix-express-ad',
  HelixSearchV2 = 'helix-search-v2',
}
